export interface SubparticipanteModel {
  tipo_identificacion: string;
  numero_documento: string;
  mayor_edad: boolean;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  rango_edad: string;
  rol: string;
  grupo_etnico: string;
  orientacion_sexual: string;
  identidad: string;
  participante_id: number;
  postulacion_id: number;
}

export const initialValuesSubparticipanteModel = {
  tipo_identificacion: "",
  numero_documento: "",
  mayor_edad: false,
  primer_nombre: "",
  segundo_nombre: "",
  primer_apellido: "",
  segundo_apellido: "",
  rango_edad: "",
  rol: "",
  grupo_etnico: "",
  orientacion_sexual: "",
  identidad: "",
  participante_id: 0,
  postulacion_id: 0,
};
